export const PREMIUM_TAB_PATHS = ["/habits", "/insight", "/rules"] as const;

export type PremiumTabPath = (typeof PREMIUM_TAB_PATHS)[number];

export type PremiumTabId = "habits" | "insight" | "rules";

export function isPremiumTabPath(pathname: string): pathname is PremiumTabPath {
  return (PREMIUM_TAB_PATHS as readonly string[]).includes(pathname);
}

export function premiumTabPathToId(path: PremiumTabPath): PremiumTabId {
  return path.slice(1) as PremiumTabId;
}
